module.exports = __webpack_public_path__ + "static/media/typewriter.2e79094b.jpg";